// extracted by mini-css-extract-plugin
module.exports = {"generalCardGrid":"GatewayCommonCardStyle_generalCardGrid__1tfl0","cardTitleExtraPadding":"GatewayCommonCardStyle_cardTitleExtraPadding__1SbMt"};